$(function() {
  // 鄂ｮ謠帙�蟇ｾ雎｡縺ｨ縺吶ｋclass螻樊ｧ縲�
  var $elem = $('.js-image-switch');
  // 鄂ｮ謠帙�蟇ｾ雎｡縺ｨ縺吶ｋsrc螻樊ｧ縺ｮ譛ｫ蟆ｾ縺ｮ譁�ｭ怜�縲�
  var sp = '_sp.';
  var pc = '_pc.';
  // 逕ｻ蜒上ｒ蛻�ｊ譖ｿ縺医ｋ繧ｦ繧｣繝ｳ繝峨え繧ｵ繧､繧ｺ縲�
  var replaceWidth = 768;

  function imageSwitch() {
    // 繧ｦ繧｣繝ｳ繝峨え繧ｵ繧､繧ｺ繧貞叙蠕励☆繧九�
    var windowWidth = parseInt($(window).width());

    // 繝壹�繧ｸ蜀�↓縺ゅｋ縺吶∋縺ｦ縺ｮ`.js-image-switch`縺ｫ驕ｩ蠢懊＆繧後ｋ縲�
    $elem.each(function() {
      var $this = $(this);
      // 繧ｦ繧｣繝ｳ繝峨え繧ｵ繧､繧ｺ縺�768px莉･荳翫〒縺ゅｌ縺ｰ_sp繧胆pc縺ｫ鄂ｮ謠帙☆繧九�
      if(windowWidth >= replaceWidth) {
        $this.attr('src', $this.attr('src').replace(sp, pc));

      // 繧ｦ繧｣繝ｳ繝峨え繧ｵ繧､繧ｺ縺�768px譛ｪ貅縺ｧ縺ゅｌ縺ｰ_pc繧胆sp縺ｫ鄂ｮ謠帙☆繧九�
      } else {
        $this.attr('src', $this.attr('src').replace(pc, sp));
      }
    });
  }
  imageSwitch();

  // 蜍慕噪縺ｪ繝ｪ繧ｵ繧､繧ｺ縺ｯ謫堺ｽ懷ｾ�0.2遘堤ｵ後▲縺ｦ縺九ｉ蜃ｦ逅�ｒ螳溯｡後☆繧九�
  var resizeTimer;
  $(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      imageSwitch();
    }, 200);
  });
});